document.addEventListener(
	'DOMContentLoaded',
	() => {
		const playButton = document.querySelector('.hero-article__image__play');
		const modal = document.getElementById('videoModal');
		const closeModalBtn = document.getElementById('closeModalBtn');

		if (playButton) {
			// If video hide progress bar and article content
			document.querySelector('.progress-bar').style.display = 'none';
			document.querySelector('.article-content').style.display = 'none';

			playButton.addEventListener('click', () => {
				const videoId = playButton.getAttribute('data-id');
				youtubeVideo.src = `https://www.youtube.com/embed/${videoId}`;
				modal.style.display = 'flex';
				document.body.style.overflow = 'hidden';
			});

			closeModalBtn.addEventListener('click', () => {
				modal.style.display = 'none';
				youtubeVideo.src = '';
				document.body.style.overflow = '';
			});
		}
	},
	false,
);
